import { Facebook, Instagram } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const TikTokIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15.2a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.73a8.19 8.19 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.16z"/>
  </svg>
);

const socialLinks = [
  {
    name: "Facebook",
    icon: Facebook,
    href: "https://m.facebook.com/profile.php?id=61584131013321",
    hoverBg: "hsl(221,44%,41%)",
    hoverGlow: "0 0 25px hsla(221,44%,41%,0.5)",
  },
  {
    name: "Instagram",
    icon: Instagram,
    href: "https://www.instagram.com/curryliciousskanor?igsh=MTM2YzgwdHIwcjRkMA==",
    hoverBg: "hsl(340,75%,54%)",
    hoverGlow: "0 0 25px hsla(340,75%,54%,0.5)",
  },
  {
    name: "TikTok",
    icon: null,
    href: "#",
    hoverBg: "hsl(0,0%,10%)",
    hoverGlow: "0 0 25px hsla(0,0%,10%,0.4)",
  },
];

const SocialMedia = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 md:py-24 bg-card/50 border-t border-border">
      <div className="container-custom text-center">
        {/* Decorative gold line */}
        <div className="w-16 h-[2px] bg-gold/60 mx-auto mb-8" />

        <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-3">
          {t('footer.follow')}
        </h2>
        <p className="text-muted-foreground mb-12 max-w-md mx-auto">
          {t('social.description')}
        </p>

        <div className="flex justify-center gap-8 md:gap-12">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.name}
              className="group flex flex-col items-center gap-3"
            >
              <div
                className="w-20 h-20 rounded-2xl bg-white/5 backdrop-blur-sm border border-gold/20 text-gold flex items-center justify-center transition-all duration-500 group-hover:scale-110 group-hover:-translate-y-2 group-hover:text-white group-hover:border-transparent"
                style={{
                  // @ts-ignore
                  '--hover-bg': link.hoverBg,
                  '--hover-glow': link.hoverGlow,
                }}
                onMouseEnter={(e) => {
                  const el = e.currentTarget;
                  el.style.backgroundColor = link.hoverBg;
                  el.style.boxShadow = link.hoverGlow;
                }}
                onMouseLeave={(e) => {
                  const el = e.currentTarget;
                  el.style.backgroundColor = '';
                  el.style.boxShadow = '';
                }}
              >
                {link.icon ? <link.icon size={34} /> : <TikTokIcon size={34} />}
              </div>
              <span className="text-sm font-medium text-muted-foreground group-hover:text-gold transition-colors duration-500">
                {link.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;
